import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  codigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
  servicio: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  comienzoOperaciones: { value: null, matchMode: FilterMatchMode.DATE_IS },
  finOperaciones: { value: null, matchMode: FilterMatchMode.DATE_IS },
  fechaFinDescarga: { value: null, matchMode: FilterMatchMode.DATE_IS },
  aperturaStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  cierreStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  cutOff: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
